import { useEffect } from 'react';
import {
  setSharedDataActiveTimelineChronologyType,
  setTimelineChronologyActiveEntryIndex,
  setTimelineChronologySelectedEntryIds,
  TimelineChronologyType,
  useAppDispatch
} from '@/store';
import { TimelineChronologyPage } from './TimelineChronologyPage';

export const TimelinePageContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSharedDataActiveTimelineChronologyType(TimelineChronologyType.TIMELINE));

    return () => {
      dispatch(setSharedDataActiveTimelineChronologyType(null));
      dispatch(
        setTimelineChronologyActiveEntryIndex({
          key: TimelineChronologyType.TIMELINE,
          data: null
        })
      );
      dispatch(
        setTimelineChronologySelectedEntryIds({
          key: TimelineChronologyType.TIMELINE,
          data: []
        })
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <TimelineChronologyPage />;
};
